<form [formGroup]="loginFormGroup" class="mt-3 offer-detail__form offer-detail__form--register"
      (ngSubmit)="onRegisterNext(parentStepper)">
  <mat-card appearance="outlined" class="mt-3 offer-detail__card offer-detail__card--register-info">
    <mat-card-content>
      <div class="row offer-detail__row offer-detail__row--register-info">
        <div class="col-12 offer-detail__register-info"
             [innerHTML]="translationService.getTranslation('account_already_exists_description')"></div>
      </div>
    </mat-card-content>
  </mat-card>
  <mat-card appearance="outlined" class="mt-3 offer-detail__card offer-detail__card--register-form">
    <mat-card-content>
      <div class="row offer-detail__row offer-detail__row--register-form">
        <div class="col-12 pl-15 offer-detail__register-form-text"
             [innerHTML]="translationService.getTranslation('account_register')"></div>
      </div>
      <mat-form-field class="col-12 mt-3 offer-detail__form-field offer-detail__form-field--email">
        <mat-label [innerHTML]="translationService.getTranslation('register_email')"></mat-label>
        <input matInput formControlName="email" required
               [value]="loginFormGroup.get('email').value"
               [class.is-valid]="loginFormGroup.get('email').valid">
        @if (loginFormGroup.get('email').pending) {
          <mat-spinner class="iconInInput offer-detail__input-spinner"
                       matSuffix [diameter]="18"
                       style="float: right; margin-left: 18px"></mat-spinner>
        }
        @if (loginFormGroup.get('email').valid) {
          <mat-icon class="iconInInput offer-detail__input-icon" matSuffix>
            check
          </mat-icon>
        } @else {
          <mat-error class="offer-detail__error">
            {{
              loginFormGroup.get('email').hasError('required')
                ? translationService.getTranslation('error_email_empty')
                : translationService.getTranslation('error_email_invalid')
            }}
          </mat-error>
        }
      </mat-form-field>
      @if (showPasswordInput()) {
        <div class="row col-12 mt-3 offer-detail__row offer-detail__row--password-text">
          <div [innerHTML]="translationService.getTranslation('offer.register.passwordText')"
               class="offer-detail__password-text"></div>
        </div>
        <mat-form-field
          class="col-12 mt-2 mb-3 offer-detail__form-field offer-detail__form-field--password"
          [hintLabel]="getPasswordComplexityHint()">
          <mat-label [innerHTML]="translationService.getTranslation('register_password')"></mat-label>
          <input matInput formControlName="password" type="password" required
                 [value]="loginFormGroup.get('password').value"
                 [class.is-valid]="loginFormGroup.get('password').valid">
          @if (loginFormGroup.get('password').pending) {
            <mat-spinner class="iconInInput offer-detail__input-spinner"
                         matSuffix [diameter]="18"
                         style="float: right; margin-left: 18px"></mat-spinner>
          }
          @if (loginFormGroup.get('password').valid) {
            <mat-icon class="iconInInput offer-detail__input-icon" matSuffix>check</mat-icon>
          }
          @if (loginFormGroup.get('password').invalid) {
            <mat-error class="offer-detail__error" [innerHTML]="getPasswordErrorMessage()"></mat-error>
          }
        </mat-form-field>
      }
    </mat-card-content>
  </mat-card>
  <div class="text-end mt-3 offer-detail__next-btn offer-detail__next-btn--register">
    <button mat-raised-button
            color="primary" type="submit"
            [disabled]="!loginFormGroup.valid"
            [innerHTML]="translationService.getTranslation('button_next')">
    </button>
  </div>
</form>
